define('viewmodels/RiskRating/AttributeConfiguration',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {

        var AttributeConfigVM = {
            activate: activate,
            attached: attached,
            detached: detached,
            logger: logger,
            appsecurity: appsecurity,

            // methods, events, popUps
            RRAreaTabClick: RRAreaTabClick,          
            GetMasterAreas: GetMasterAreas,
            addAttributePopup: addAttributePopup,
            addAreaPopup: addAreaPopup,
            saveAttribute: saveAttribute,
            saveArea: saveArea,
            addMasterArea: addMasterArea,
            EditAttributePopUp: EditAttributePopUp,
            DeleteAttributePopUp: DeleteAttributePopUp,
            ExpandAttributeClick: ExpandAttributeClick,
            addAttributeOptionPopUp: addAttributeOptionPopUp,
            saveAttributeOption: saveAttributeOption,
            EditAttributeOptionPopUp: EditAttributeOptionPopUp,
            DeleteAttributeOptionPopUp: DeleteAttributeOptionPopUp,

            //observables
            RRAreaList: ko.observableArray([]),
            RiskAreas: ko.observable(),
            SelectedMRRAreaId: ko.observable(),
            AttributesList: ko.observableArray([]),
            EditAttributeFlag: ko.observable(),
            addPopUpCss: ko.observable(),
            popUpTitle: ko.observable(),
            editableAttribute: ko.observable(),
            editableArea: ko.observable(),
            SelectedAssessmentType: ko.observable(),
            SelectedComponentIAreaId: ko.observable(),
            AssessmentTypeList: ko.observableArray(),
            AssessmentTypeListEdit: ko.observableArray(),
            AttributeInputTypeList: ko.observableArray([]),
            SelectedAttributeRow: ko.observableArray([]),
            CurrentPageNumber: ko.observable(),
            SelectedAttributeId: ko.observable(),
            AttributeOptionsList: ko.observableArray([]),
            editableAttributeOption: ko.observable(),
            EditAttributeOptionFlag: ko.observable(),
            RATListforOptions: ko.observableArray(),
            RATListforOptionsEdit: ko.observableArray()
        };

        return AttributeConfigVM;
        
        var AttributeTableObj = false;
        var AttributeOptionTableObj = false;

        function activate() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                GetRRAreas();
                var ATypeArray = [{ "AttributeInputTypeName": "Dropdown", "AttributeInputTypeId": "1" },
                { "AttributeInputTypeName": "Text", "AttributeInputTypeId": "2" }];
                AttributeConfigVM.AttributeInputTypeList(ATypeArray);
                $('#AttributesDiv').hide();
                $('#AttributeOptionsDiv').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#region Get Methods

        function GetRRAreas() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRRAreas",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                AttributeConfigVM.RRAreaList(jsonResult);
                                $('#loadingMainImgDiv').show();
                                $('#RRAreasTab').tabs();
                                $('#RRAreasTab').tabs('refresh');
                                $('#RRAreasTab').tabs({ active: 0 });
                                $($('#RRAreasTabsUL li').get(0)).trigger('click');
                                scrollableTabs(); 
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                                $('#errorAreas').show();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Risk Rating Areas. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Risk Rating Areas. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllRRAreas() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function GetAttributes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAttributes",
                    type: "GET",
                    headers: headers,
                    data: { "SelectedMRRAreaId": AttributeConfigVM.SelectedMRRAreaId() }
                })
                    .success(function (jsonResult, success) {
                        $('#loadingMainImgDiv').hide();
                        $('#AttributesDiv').show();
                        if (jsonResult !== null) {


                            tableObj = $('#tblAttributes').DataTable();
                            tableObj.destroy();
                            $('#tblAttributes tbody tr').remove();
                            
                            AttributeTableObj = undefined;


                            var mappedList = $.map(jsonResult, function (result) {
                                return new AttributeModel(result);
                            });

                            AttributeConfigVM.AttributesList(mappedList);

                            AttributeTableObj = $('#tblAttributes').DataTable({
                                "order": [],
                                "aaSorting": [],
                                "bResponsive": true,
                                "aoColumnDefs": [
                                    {
                                        "aTargets": [0],
                                        "bSortable": false
                                    },
                                    {
                                        "aTargets": [5],
                                        "bSortable": false
                                    }
                                ]
                            });
                            $('#tblAttributes').DataTable().draw(false);

                        }
                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Attributes. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                        }

                    })

                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAttribues() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAttributes() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }

        }

        function GetAttributeOptions() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAttributeOptions?SelectedAttributeId=" + AttributeConfigVM.SelectedAttributeId(),
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult !== null) {

                            tableOptObj = $('#tblAttributeOptions').DataTable();
                            tableOptObj.destroy();
                            $('#tblAttributeOptions tbody tr').remove();

                            AttributeOptionTableObj = undefined;
                            
                            var mappedList = $.map(jsonResult, function (result) {
                                return new AttributeOptionModel(result);
                            });

                            AttributeConfigVM.AttributeOptionsList(mappedList);

                            var param = AttributeConfigVM.SelectedAttributeRow();
                            var tr = param[0];
                            var row = AttributeTableObj.row(tr);
                            row.child("");
                            row.child(document.getElementById('AttributeOptionsDiv').innerHTML).show();
                            tr.addClass('shown');

                            ko.applyBindingsToNode($('#btnAddOption').get(0), {
                                click: AttributeConfigVM.addAttributeOptionPopUp
                            }, param[1]);

                            AttributeOptionTableObj = $('#tblAttributeOptions').DataTable({
                                "order": [],
                                "aaSorting": [],
                                "aLengthMenu": [10, 15, 20, 25],
                                "bResponsive": true,
                                "aoColumnDefs": [
                                    {
                                        "aTargets": [3],
                                        "bSortable": false
                                    }
                                ]
                            });
                            $('#tblAttributeOptions').DataTable().draw(false);

                            if (AttributeConfigVM.AttributeOptionsList().length > 0) 
                            {
                                for (var i = 1; i < $('#tblAttributeOptions').find('tr').length; i++)
                                {
                                    var editoptionDiv = $($($('#tblAttributeOptions').find('tr').get(i)).find('td').get(3)).find('a').get(0);
                                    var deleteoptionDiv = $($($('#tblAttributeOptions').find('tr').get(i)).find('td').get(3)).find('a').get(1);
                                    ko.cleanNode(editoptionDiv);
                                    ko.cleanNode(deleteoptionDiv);

                                    ko.applyBindingsToNode(editoptionDiv, {
                                        click: AttributeConfigVM.EditAttributeOptionPopUp
                                    }, AttributeConfigVM.AttributeOptionsList()[i - 1]);

                                    ko.applyBindingsToNode(deleteoptionDiv, {
                                        click: AttributeConfigVM.DeleteAttributeOptionPopUp
                                    }, AttributeConfigVM.AttributeOptionsList()[i - 1]);
                                }
                            }
                        }
                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Attribute Options. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                        }

                    })

                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAttribues() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAttributeOptions() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Events, TabClick & Other Methods

        function RRAreaTabClick(data, event) {
            try {
                $('#loadingMainImgDiv').show();
                $('#AttributesDiv').hide();
                AttributeConfigVM.SelectedMRRAreaId(data.MRRAId);
                AttributeConfigVM.AssessmentTypeList(data.RATArray);
                $('#RRAreasTabsUL li').removeClass('active');
                $('#'+ data.MRRAId).addClass('active');
                //$('#lblRRAName').empty();
                //document.getElementById('lblRRAName').innerHTML = data.MRRAName;
                //$('#lblApplicability').empty();
                //document.getElementById('lblApplicability').innerHTML = data.ApplicableRATNames;

                GetAttributes();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRAreaTabClick() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function saveAttribute(data, event) {
            try {
                $('#valErrorRRA').hide();

                if (AttributeConfigVM.editableAttribute().AttributeName() === "") {
                    $('#valErrorRRA').show();
                    $('#valErrorRRA').text('Attribute Name is required.');
                }
                else if (!AttributeConfigVM.EditAttributeFlag() && AttributeConfigVM.SelectedAssessmentType().length === 0) {
                    $('#valErrorRRA').show();
                    $('#valErrorRRA').text('Please select atleast one Assessment Type');
                }
                else if ($("#AttributeType option:selected").text() === "Select...") {
                    $('#valErrorRRA').show();
                    $('#valErrorRRA').text('Please select Attribute Type');
                }
                else {
                    if (!AttributeConfigVM.EditAttributeFlag())
                        addAttribute(data);
                    else
                        editAttribute(data);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveAttribute() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function saveArea(data, event) {
            try {
                $('#valErrorRRA').hide();                             
                addMasterArea(data);
                    
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveAttribute() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }
        //#region Expand Attribute Methods
        function ExpandAttributeClick(data, event) {
            try {
                var tr = $(event.currentTarget).closest('tr');
                var row = AttributeTableObj.row(tr);

                var AttId = ko.toJS(data.AttributeId());
                AttributeConfigVM.SelectedAttributeId(AttId);

                var RATArray = ko.toJS(data.RATArray());
                AttributeConfigVM.RATListforOptions(RATArray);

                AttributeConfigVM.SelectedAttributeRow([]);
                AttributeConfigVM.SelectedAttributeRow.push(tr);
                AttributeConfigVM.SelectedAttributeRow.push(data);
                checkExpandedRow(row, false);

                if (row.child.isShown()) {
                    row.child.hide();
                    tr.removeClass('shown');
                    AttributeOptionTableObj = false;
                    AttributeConfigVM.SelectedAttributeId([]);
                }
                else {
                    GetAttributeOptions();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExpandAttributeClick() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function checkExpandedRow(row, isPaginating) {
            try {
                var currentRowIndex;
                var rowsInTable = $('#tblAttributes').find('tr');
                if (isPaginating) {
                    currentRowIndex = -1;
                } else {
                    currentRowIndex = row.index();
                }

                var info = AttributeTableObj.page.info();
                for (var i = 1, j = rowsInTable.length; i < j; i++) {
                    var tr = $('#tblAttributes').find('tr').get(i);
                    if (AttributeTableObj.row(tr).index() !== currentRowIndex) {
                        var tableRowIndex = 0;
                        if (isPaginating) {
                            tableRowIndex = (AttributeConfigVM.CurrentPageNumber() * info.length) + (i - 1);
                        } else {
                            tableRowIndex = (info.page * info.length) + (i - 1);
                        }

                        if ((AttributeTableObj.row(tableRowIndex).child() != undefined)
                            && (AttributeTableObj.row(tableRowIndex).child.isShown())) {
                            AttributeTableObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown');
                            j = $('#tblAttributes').find('tr').length;
                        }
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RiskRatingFactorSetup.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        function saveAttributeOption(data, event) {
            try {
                $('#valErrorOptions').hide();

                if (AttributeConfigVM.editableAttributeOption().AttributeOptionName() === "") {
                    $('#valErrorOptions').show();
                    $('#valErrorOptions').text('Option name is required.');
                }
                else if (!AttributeConfigVM.EditAttributeOptionFlag() && AttributeConfigVM.SelectedAssessmentType().length === 0) {
                    $('#valErrorOptions').show();
                    $('#valErrorOptions').text('Please select atleast one Assessment Type');
                }
                else {
                    if (!AttributeConfigVM.EditAttributeOptionFlag())
                        addAttributeOption(data);
                    else
                        editAttributeOption(data);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveAttributeOption() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        function GetMasterAreas() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetMasterAreas",
                    type: "GET",
                    headers: headers
                })
                        .success(function (JsonResult, status) {
                            if (JsonResult == 0 || JsonResult == null) {

                            }
                            else {

                                if (JsonResult.length > 0) {
                                    var mappedFirstList = $.map(JsonResult, function (result) {
                                        return new AreaModel({ AreaId: result.RRAId, AreaName: result.RRAName });
                                    });
                                    AttributeConfigVM.RiskAreas(mappedFirstList);
                                    $('#MasterAreaOptions').multiselect();
                                }

                            }
                        })
                        .fail(function (JsonResult, status) {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                            }
                            else {
                                var msg = 'Exception: ' + error.statusText + ' | Source: GetMasterAreas() method in RiskLevel.js';
                                logger.logMessage(msg);
                            }
                        })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetMasterAreas() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }

            }
            
        //#region MasterAreas
        function addAreaPopup(data) {
            try {       
                AttributeConfigVM.addPopUpCss(true);
                AttributeConfigVM.popUpTitle("Add Area");
                AttributeConfigVM.SelectedComponentIAreaId([]);
               // var newAttribute = new AreaModel({ AreaId: -999, AreaName: "", AreaDescription: ""});
               // AttributeConfigVM.editableArea(newAttribute);

                GetMasterAreas();

              //  $('#MasterAreaOptions').multiselect();
             //   $('#RRAreaDropdown').multiselect();
                $('#ModalAddMasterArea').modal('show');
                $('#AreaDescriptionTextArea').attr('placeholder', 'Area Description');
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttributePopup() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }



        //#endregion

        //#region PopUps

        //#region Attributes

        function addAttributePopup(data) {
            try {
                AttributeConfigVM.EditAttributeFlag(false);
                AttributeConfigVM.addPopUpCss(true);
                AttributeConfigVM.popUpTitle("Add Attribute");
                AttributeConfigVM.SelectedAssessmentType([]);
                var newAttribute = new AttributeModel({ AttributeId: -999, AttributeName: "", AttributeDescription: "", InputType: "" });
                AttributeConfigVM.editableAttribute(newAttribute);
                AttributeConfigVM.AttributeInputTypeList();
                $('#RAApplicability').multiselect();
                $('#ModalAddAttribute').modal('show');
                $('#AttributeDescriptionTextArea').attr('placeholder', 'Attribute Description');
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttributePopup() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function EditAttributePopUp(data) {
            try {
                AttributeConfigVM.EditAttributeFlag(true);
                AttributeConfigVM.addPopUpCss(false);
                AttributeConfigVM.popUpTitle("Edit Attribute");
                AttributeConfigVM.SelectedAssessmentType([]);
                AttributeConfigVM.AssessmentTypeListEdit([]);
                AttributeConfigVM.AttributeInputTypeList();
                var editAttribute = new AttributeModel({
                    AttributeId: data.AttributeId(), AttributeName: data.AttributeName(), AttributeDescription: data.AttributeDescription(),
                    InputType: data.InputType(), ApplicableRATNames: data.ApplicableRATNames(), ApplicableRATIds: data.ApplicableRATIds()
                });
                AttributeConfigVM.editableAttribute(editAttribute);
                var ATArray = [];
                for (var i = 0; i < AttributeConfigVM.AssessmentTypeList().length; i++) {
                    var count = 0;
                    for (var j = 0; j < data.RATArray().length; j++) {
                        if (data.RATArray()[j].AssessmentId.toString().trim() === AttributeConfigVM.AssessmentTypeList()[i].AssessmentId.toString().trim())
                            count++;
                    }
                   // if (count === 0)
                        ATArray.push(AttributeConfigVM.AssessmentTypeList()[i]);
                }
                if (ATArray.length === 0) {
                    $('#RAApplicabilityEdit').hide();
                }
                else {
                    $('#RAApplicabilityEdit').show();
                    AttributeConfigVM.AssessmentTypeListEdit(ATArray);
                    $('#RAApplicabilityEdit').multiselect();
                }
                $('#RATApplicability').empty();
                document.getElementById('RATApplicability').innerHTML = data.ApplicableRATNames();
                $('#ModalAddAttribute').modal('show');
                $('#AttributeDescriptionTextArea').attr('placeholder', 'Attribute Description');
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditAttributePopUp() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function DeleteAttributePopUp(data, event) {
            try {
                app.showMessage('Are you sure you want to delete this Attribute?', 'Delete Attribute', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteAttribute(data.AttributeId());
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteAttributePopUp() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region AttributeOptions

        function addAttributeOptionPopUp(data, event) {
            try {
                AttributeConfigVM.EditAttributeOptionFlag(false);
                AttributeConfigVM.addPopUpCss(true);
                AttributeConfigVM.popUpTitle("Add Option");
                AttributeConfigVM.SelectedAssessmentType([]);
                var newOption = new AttributeOptionModel({ AttributeOptionId: -999, AttributeOptionName: "" });
                AttributeConfigVM.editableAttributeOption(newOption);
                $('#RATApplicabilityOptions').multiselect();
                $('#ModalAddAttributeOption').modal('show');
                $('#modalContentOptions').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttributeOptionsPopUp() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function EditAttributeOptionPopUp(data, event) {
            try {
                AttributeConfigVM.EditAttributeOptionFlag(true);
                AttributeConfigVM.addPopUpCss(false);
                AttributeConfigVM.popUpTitle("Edit Option");
                AttributeConfigVM.SelectedAssessmentType([]);
                AttributeConfigVM.RATListforOptionsEdit([]);
                var editOption = new AttributeOptionModel({
                    AttributeOptionId: data.AttributeOptionId(), AttributeOptionName: data.AttributeOptionName(),
                    ApplicableRATNamesOptions: data.ApplicableRATNamesOptions(), ApplicableRATIdsOptions: data.ApplicableRATIdsOptions()
                });
                AttributeConfigVM.editableAttributeOption(editOption);
                var ATArray = [];
                for (var i = 0; i < AttributeConfigVM.RATListforOptions().length; i++) {
                    var count = 0;
                    for (var j = 0; j < data.RATArrayOptions().length; j++) {
                        if (data.RATArrayOptions()[j].AssessmentId.toString().trim() === AttributeConfigVM.RATListforOptions()[i].AssessmentId.toString().trim())
                            count++;
                    }
                    if (count === 0)
                        ATArray.push(AttributeConfigVM.RATListforOptions()[i]);
                }
                if (ATArray.length === 0) {
                    $('#RATApplicabilityOptionsEdit').hide();
                }
                else {
                    $('#RATApplicabilityOptionsEdit').show();
                    AttributeConfigVM.RATListforOptionsEdit(ATArray);
                    $('#RATApplicabilityOptionsEdit').multiselect();
                }
                $('#RATApplicabilityOptText').empty();
                document.getElementById('RATApplicabilityOptText').innerHTML = data.ApplicableRATNamesOptions();
                $('#ModalAddAttributeOption').modal('show');
                $('#modalContentOptions').css({
                    'margin-top': 'auto'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditAttributeOptionPopUp() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function DeleteAttributeOptionPopUp(data, event) {
            try {
                app.showMessage('Are you sure you want to delete this Option?', 'Delete Option', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteAttributeOption(data.AttributeOptionId());
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteAttributeOptionPopUp() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#endregion


        //#region Set Methods

        //#region Attributes

        function addMasterArea(data) {
            try {
                var AreaIds = "";
                for (var i = 0; i < AttributeConfigVM.SelectedComponentIAreaId().length; i++) {
                    if (AreaIds === "")
                        AreaIds += AttributeConfigVM.SelectedComponentIAreaId()[i];
                    else
                        AreaIds += "," + AttributeConfigVM.SelectedComponentIAreaId()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/AddMasterArea",
                    headers: headers,
                    type: "POST",                  
                    data: { ApplicableAreaIds: AreaIds}
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult > 1) {
                            logger.logSuccess('Attribute has been added Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            $('#ModalAddAttribute').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetRRAreas();
                        }
                        else
                            logger.logError('An error occurred while adding the attribute. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addAttribute() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttribute() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function addAttribute(data) {
            try {
                var selectedInputType = $("#AttributeType option:selected").text();
                var RATIds = "";
                for (var i = 0; i < AttributeConfigVM.SelectedAssessmentType().length; i++) {
                    if (RATIds === "")
                        RATIds += AttributeConfigVM.SelectedAssessmentType()[i];
                    else
                        RATIds += "," + AttributeConfigVM.SelectedAssessmentType()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/AddAttribute?MRRAId=" + parseInt(AttributeConfigVM.SelectedMRRAreaId()),
                    type: "POST",

                    headers: headers,
                    data: { AttributeName: data.AttributeName(), AttributeDescription: data.AttributeDescription(), InputType: selectedInputType, ApplicableRATIds: RATIds }
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult === 1) {
                            logger.logSuccess('Attribute has been added Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            $('#ModalAddAttribute').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAttributes();
                        }
                        else
                            logger.logError('An error occurred while adding the attribute. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addAttribute() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttribute() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function editAttribute(data) {
            try {
                var selectedInputType = $("#AttributeType option:selected").text();
                var RATIds = data.ApplicableRATIds();
                for (var i = 0; i < AttributeConfigVM.SelectedAssessmentType().length; i++) {
                        RATIds += "," + AttributeConfigVM.SelectedAssessmentType()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/EditAttribute",
                    type: "POST",
                    headers: headers,
                    data: { AttributeId: data.AttributeId(), AttributeName: data.AttributeName(), AttributeDescription: data.AttributeDescription(), InputType: selectedInputType, ApplicableRATIds: RATIds }
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult > 0) {
                            logger.logSuccess('Attribute has been edited Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            $('#ModalAddAttribute').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAttributes();
                        }
                        else
                            logger.logError('An error occurred while editing the attribute. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in editAttribute() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editAttribute() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region AttributeOtions

        function addAttributeOption(data) {
            try {
                var RATIds = "";
                for (var i = 0; i < AttributeConfigVM.SelectedAssessmentType().length; i++) {
                    if (RATIds === "")
                        RATIds += AttributeConfigVM.SelectedAssessmentType()[i];
                    else
                        RATIds += "," + AttributeConfigVM.SelectedAssessmentType()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/AddAttributeOption?MRRAId=" + parseInt(AttributeConfigVM.SelectedMRRAreaId()) +
                        "&AttributeId=" + parseInt(AttributeConfigVM.SelectedAttributeId()),
                    type: "POST",
                    headers: headers,
                    data: { AttributeOptionName: data.AttributeOptionName(), ApplicableRATIdsOptions: RATIds }
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult === 1) {
                            logger.logSuccess('Option has been added Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            $('#ModalAddAttributeOption').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAttributeOptions();
                        }
                        else
                            logger.logError('An error occurred while adding the option. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addAttributeOption() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: addAttributeOption() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function editAttributeOption(data) {
              try {
                var RATIds = data.ApplicableRATIdsOptions();
                for (var i = 0; i < AttributeConfigVM.SelectedAssessmentType().length; i++) {
                        RATIds += "," + AttributeConfigVM.SelectedAssessmentType()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/EditAttributeOption?AttributeId=" + parseInt(AttributeConfigVM.SelectedAttributeId()),
                    type: "POST",
                    headers: headers,
                    data: { AttributeOptionId: data.AttributeOptionId(), AttributeOptionName: data.AttributeOptionName(), ApplicableRATIdsOptions: RATIds }
                })
                    .success(function (jsonResult, success) {

                        if (jsonResult > 0) {
                            logger.logSuccess('Option has been edited Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            $('#ModalAddAttributeOption').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAttributeOptions();
                        }
                        else
                            logger.logError('An error occurred while editing the option. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in editAttributeOption() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: editAttributeOption() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#endregion


        //#region Delete Methods

        function DeleteAttribute(RRAId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/DeleteAttribute?attributeID=" + RRAId,
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Attribute has been deleted Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            GetAttributes();
                        }
                        else
                            logger.logError('An error occurred while deleting the attribute. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteAttribute() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteAttribute() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function DeleteAttributeOption(OptionId) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/DeleteAttributeOption?OptionId=" + OptionId,
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Option has been deleted Successfully.', 'Success', system.getModuleId(AttributeConfigVM), true);
                            GetAttributeOptions();
                        }
                        else
                            logger.logError('An error occurred while deleting the option. Please contact your Administrator.', 'Error', system.getModuleId(AttributeConfigVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteAttributeOption() method in AttributeConfiguration.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteAttributeOption() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion


        //#region Model Definitions

        function AttributeModel(item) {
            try {
                var self = this;
                self.AttributeId = ko.observable(item.AttributeId);
                self.AttributeName = ko.observable(item.AttributeName);
                self.AttributeDescription = ko.observable(item.AttributeDescription);
                self.InputType = ko.observable(item.InputType);
                self.ApplicableRATNames = ko.observable(item.ApplicableRATNames);
                self.ApplicableRATIds = ko.observable(item.ApplicableRATIds);
                self.RATArray = ko.observable(item.RATArray);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AttributeModel() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }
        function AreaModel(item) {
            try {
                var self = this;
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
              
                //self.AreaDescription = ko.observable(item.AreaDescription);
                //self.ApplicableRATNames = ko.observable(item.ApplicableRATNames);
                //self.ApplicableRATIds = ko.observable(item.ApplicableRATIds);
                //self.RATArray = ko.observable(item.RATArray);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AttributeModel() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function AttributeOptionModel(item) {
            try {
                var self = this;
                self.AttributeOptionId = ko.observable(item.AttributeOptionId);
                self.AttributeOptionName = ko.observable(item.AttributeOptionName);
                self.OptionOverallRank = ko.observable(item.OptionOverallRank);
                self.ApplicableRATNamesOptions = ko.observable(item.ApplicableRATNamesOptions);
                self.ApplicableRATIdsOptions = ko.observable(item.ApplicableRATIdsOptions);
                self.RATArrayOptions = ko.observable(item.RATArrayOptions);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AttributeModel() method in AttributeConfiguration.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

    });
